import React from "react";
import { fetchCarePlanAuditLogsService } from "../../../services/dashboardServices";
import WithAuditLogs from "./WithAuditLogs";

const CarePlanAuditLogs = ({
  carePlanId,
  isDraft = false,
  nhsNumber,
  onClose,
}) => {
  const title = isDraft
    ? "Audit Logs for Draft Care Plan: " + nhsNumber
    : "Audit Logs for Active Care Plan: " + nhsNumber;

  // use the correct service export
  const fetchFn = (id) => fetchCarePlanAuditLogsService(id, isDraft);

  return (
    <WithAuditLogs
      id={carePlanId}
      title={title}
      fetchFn={fetchFn}
      onClose={onClose}
    />
  );
};

export default CarePlanAuditLogs;
